/* eslint-disable jsx-a11y/anchor-is-valid */
import { OrientationProps } from '../../Menu/@types/MenuProps';
import { MenuItemProps } from '../@types/MenuItemProps';

type StyledLinkProps = {
	orientation?: OrientationProps;
	children?: React.ReactNode;
	submenu?: boolean;
} & Pick<MenuItemProps, 'type' | 'itemProps' | 'id' | 'highlight' | 'blockClass'>;

const StyledLink = ({
	itemProps,
	id,
	children,
	highlight,
	blockClass,
	type,
	orientation,
	submenu = false,
}: StyledLinkProps) => {
	const renderTokens = (): string => {
		let tokens = '';

		if (highlight) {
			tokens += 'vtex-menu-2-x-styledLink--highlight styledLink--highlight pointer t-body c-emphasis';
		} else {
			tokens += ' c-on-base pointer';
		}

		if (orientation === 'vertical') {
			tokens += ' no-underline pointer';
		}

		if (submenu) {
			tokens += ' t-small';
		} else {
			tokens += ' t-body';
		}

		return tokens;
	};

	const renderComponent = (): JSX.Element => {
		switch (type) {
			case 'category':
				return (
					<a
						className={`vtex-menu-2-x-styledLink styledLink vtex-menu-2-x-styledLink--${blockClass} styledLink--${blockClass} no-underline ${renderTokens()}`}
						title={itemProps?.text}
					>
						{children}
					</a>
				);
			case 'custom':
				return (
					<a
						className={`vtex-menu-2-x-styledLink styledLink vtex-menu-2-x-styledLink--${blockClass} styledLink--${blockClass} no-underline ${renderTokens()}`}
						id={id}
						title={itemProps?.text}
					>
						{children}
					</a>
				);
			default:
				return <></>;
		}
	};

	return renderComponent();
};

export default StyledLink;
